<template>
	<div>
		<div class="flex justify-between items-end mb-10">
			<div>
				<ReportsNav />
			</div>
		</div>

		<div v-if="accountLevel == 'lp'" class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-header">

						<div class="row">
							<div class="col-sm-12 col-md-4 text-left">
								<dl class="row text-left mb-0">
									<dt class="col-auto">Total Gold</dt>
									<dd class="col">: {{ numberFormatExtend((totalGoldLp).toFixed(2)) }} g</dd>
								</dl>
							</div>

							<div class="col-sm-12 col-md-4">
								<dl class="row text-left mb-0">
									<dt class="col-auto">Available Trade Gold</dt>
									<!-- <dd class="col">: {{numberFormatExtend((totalGoldLp).minus(5).toFixed(2))}} g</dd> -->
									<dd class="col">: {{ numberFormatExtend((totalGoldLp).minus(5000).toFixed(2)) }} g</dd>
								</dl>
							</div>

							<div class="col-sm-12 col-md-4">
								<dl class="row text-left mb-0">
									<dt class="col-auto">Status</dt>
									<dd class="col">:
										<div v-if="Number((totalGoldLp)) >= 10000"
											class="alert alert-primary py-0 px-2 d-inline-block ml-3 font-weight-bold" role="alert"
											style="background-color: #2EC4B6;">
											Active
										</div>

										<div v-if="Number((totalGoldLp)) >= 5000 && Number((totalGoldLp)) < 10000"
											class="alert alert-primary py-0 px-2 d-inline-block ml-3 font-weight-bold" role="alert"
											style="background-color: orange;">
											Consider
										</div>

										<div v-if="Number((totalGoldLp)) < 5000"
											class="alert alert-primary py-0 px-2 d-inline-block ml-3 font-weight-bold" role="alert"
											style="background-color: #E71D36;">
											Suspended
										</div>
									</dd>
								</dl>

							</div>

						</div>
					</div>
					<div class="card-body pt-0">
						<div class="row">
							<div class="col-sm-12 col-md-4">
								<p class="lead"><small>Available Trade Gold = Total Gold - Reserve Gold (5 kg)</small></p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 
				<div class="row text-right mb-2">
					<div v-if="accountLevel == 'ib' || accountLevel == 'fm' || accountLevel == 'ccp'" class="col-auto mb-2 text-left">
						<FilterClient class="d-inline-block"
							filterId="holdings"
							@changeFilterClient="changeFilterClientHolding"
							:clients_prop="listClients"
						>
						</FilterClient>
					</div>
				</div> -->

		<!-- Client new -->
		<div v-if="$store.state.goldBalanceNew.apiStatus == 'loading' || $store.state.golds == null"
			class="flex justify-center py-7">
			<Loader size_prop="10rem" />
		</div>

		<div v-else-if="accountLevel == 'client'" class="text-white">
			<div class="flex gap-7 mb-6">
				<div :class="`${dataShown == 'holding' ? 'font-bold' : 'text-grey'} cursor-pointer`"
					@click="changeDataShown('holding')">Total Holdings</div>
				<div>|</div>
				<div :class="`${dataShown == 'realized' ? 'font-bold' : 'text-grey'} cursor-pointer`"
					@click="changeDataShown('realized')">Total Realized P & L</div>
			</div>

			<div v-if="$store.getters.paymentMethod == 'rped'" class="flex justify-start gap-15 mb-11">
				<div>
					<div class="text-sm mb-4">
						{{ dataShown == 'holding' ? 'Total Holding Value' : 'Total Amount Received' }}

						<Tooltip v-if="dataShown == 'holding'" class="text-xs" textAlign_prop="left"
							textPosition_prop="bottom-right" maxWidth_prop="max-w-150">
							<div class="font-semibold mb-2">Total Holding Value</div>
							<div class="font-normal mb-6">
								The total value of all assets (across all contracts) currently held, calculated based on the current
								market price — also referred to as the asset value if sold at the current market price.
							</div>

							<div class="font-semibold mb-2">Total Unrealize Profit & Loss (Estimated)</div>
							<div class="font-normal">
								The estimated profit/loss from all gold holdings across all contracts, shown in Rupiah/Dollar and
								percentage. The profit estimate is calculated using the LIFO (Last In, First Out) method.
							</div>
						</Tooltip>

						<Tooltip v-else class="text-xs" textAlign_prop="left" textPosition_prop="bottom-right"
							maxWidth_prop="max-w-150">
							<div class="font-semibold mb-2">Total Amount Received</div>
							<div class="font-normal mb-6">
								The amount received from gold sales (all contracts) that have been successfully sold.
							</div>

							<div class="font-semibold mb-2">Total Realized Profit & Loss</div>
							<div class="font-normal">
								The total realized profit/loss from all sold gold (all contracts), shown in Rupiah/Dollar and
								percentage. The profit calculation uses the LIFO (Last In, First Out) method.
							</div>
						</Tooltip>
					</div>

					<div v-if="dataShown == 'holding'" class="text-3.5xl font-bold mb-2">
						<template v-if="showHolding">
							{{ sumMetalValueAtDateAllContractShown }}
						</template>
						<template v-else>{{ currencySymbol }} &#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;</template>
					</div>

					<div v-else class="text-3.5xl font-bold mb-2">
						<template v-if="showHolding">
							{{ sumNominalDiterimaAllContractShown }}
						</template>
						<template v-else>{{ currencySymbol }} &#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;</template>
					</div>

					<!-- Unrealized -->
					<div v-if="dataShown == 'holding'"
						:class="`${(!showHolding) ? 'text-white' : sumUnrealizedPnlAllContractShown.includes('+') ? 'text-success' : sumUnrealizedPnlAllContractShown.includes('-') ? 'text-danger' : 'text-white'}`">
						<template v-if="showHolding">
							{{ sumUnrealizedPnlAllContractShown }} {{ sumPercentageUnrealizedPnlAllContract }}
						</template>
						<template v-else>&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;</template>
					</div>

					<!-- Realized -->
					<div v-else
						:class="`${!showHolding ? 'text-white' : sumRealizedPnlAllContractShown.includes('+') ? 'text-success' : sumRealizedPnlAllContractShown.includes('-') ? 'text-danger' : 'text-white'}`">
						<template v-if="showHolding">
							{{ sumRealizedPnlAllContractShown }} {{ sumPercentageRealizedPnlAllContract }}
						</template>
						<template v-else>&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;</template>
					</div>
				</div>

				<div>
					<div class="text-sm mb-4">
						{{ dataShown == 'holding' ? 'Total Gold' : 'Total Gold Sold' }}
					</div>

					<div v-if="dataShown == 'holding'" class="text-3.5xl font-bold">
						<template v-if="showHolding">
							{{ sumGramHoldingAllContract }}
						</template>
						<template v-else>&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;</template>
						g
					</div>

					<div v-else class="text-3.5xl font-bold">
						<template v-if="showHolding">
							{{ sumGramSoldAllContract }}
						</template>
						<template v-else>&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;</template>
						g
					</div>
				</div>

				<div>
					<div class="text-xs opacity-85 mt-10 cursor-pointer"
						@click="$store.commit('goldBalanceNew/setShowHolding', !showHolding)">
						<span class="bg-white rounded-full p-1 mr-1.5">
							<IconEyeClose v-if="showHolding" :sizeMultiplier_prop="1.3" :color_prop="hexColorTheme"></IconEyeClose>
							<IconEyeOpen v-else :sizeMultiplier_prop="1.3" :color_prop="hexColorTheme"> </IconEyeOpen>
						</span>
						Show/Hide
					</div>
				</div>

				<div class="grow text-right">
					<div class="text-xs opacity-85">Update {{ $store.state.lastPriceUpdateTime }}</div>
					<div class="text-grey text-xs">Auto-updated every 3 seconds</div>
				</div>
			</div>

			<div class="">
				<div v-if="$store.getters.paymentMethod == 'rped'" class="mb-6">
					Contract
					<Tooltip v-if="dataShown == 'holding'" class="text-xs" textAlign_prop="left" textPosition_prop="bottom-right"
						maxWidth_prop="max-w-150">
						<div class="font-semibold mb-1">Contract Holding Value</div>
						<div class="font-normal mb-6">
							The amount that would be received if the gold in the contract were sold at the current selling price
							(updated
							every 3 seconds). This also includes estimated profit & loss data in Rupiah/Dollar and percentage.
						</div>

						<div class="font-semibold mb-1">Pocket Holding Value</div>
						<div class="font-normal mb-6">
							The amount that would be received if the gold in the Main Pocket were sold at the current selling price
							(updated
							every 3 seconds). This also includes estimated profit & loss data in Rupiah/Dollar and percentage.
						</div>

						<div class="font-semibold mb-1">Main Pocket</div>
						<div class="font-normal mb-6">
							A feature that allows holdings within a single account to be separated for specific purposes. The Main
							Pocket is
							the primary pocket automatically created when a participant transacts on a physical gold derivative
							service
							(e.g., Gold to Mecca).
						</div>

						<div class="font-semibold mb-1">Gold to Mecca Pocket</div>
						<div class="font-normal mb-6">
							A feature that allows holdings within a single account to be separated for the purpose of preparing for
							Hajj or
							Umrah (Gold to Mecca service).
						</div>

						<div class="font-semibold mb-1">Gold Withdrawal Reserved</div>
						<div class="font-normal mb-6">
							The amount of gold that has been allocated or separated from the user's total main gold holdings because
							it is
							currently undergoing withdrawal or delivery processing.
						</div>

						<div class="font-semibold mb-1">In Buy Process & In Sell Process</div>
						<div class="font-normal">
							In Buy Process - The amount (in grams) of gold that is still open / in process / unmatched for a buy
							order.
							<br>
							In Sell Process - The quantity of gold that is still open / in process / unmatched for a sell order.
						</div>
					</Tooltip>

					<Tooltip v-else class="text-xs" textAlign_prop="left" textPosition_prop="bottom-right"
						maxWidth_prop="max-w-150">
						<div class="font-semibold mb-1">Amount Received</div>
						<div class="font-normal mb-6">
							The amount received from gold sales that have been successfully sold.
						</div>

						<div class="font-semibold mb-1">Gold Grams Sold</div>
						<div class="font-normal">
							The number of grams of gold that have been successfully sold.
						</div>
					</Tooltip>
				</div>
				<div v-for="holding in goldBalances" v-bind:key="'goldBalances' + holding.contract_id">
					<HoldingContract @update-trade-ticket="updateTradeTicket" :holding_prop="holding" :dataShown_prop="dataShown"
						:showHolding_prop="showHolding">
					</HoldingContract>
				</div>
			</div>
		</div>

		<!-- <div v-if="accountLevel == 'client'" class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-header">
						<h4> Reserved to Delivery</h4>

						<div class="row">
							<div class="col-sm-12 col-md-5 text-left">
								<dl v-for="item in reservedGold" :key="'reservedGold' + item.attributes.contractId"
									class="row mb-1 text-left">
									<dt class="col-4 text-nowrap">{{ item.name }}</dt>
									<dd class="col-8">: {{ item.totalGram }} gram</dd>
								</dl>
							</div>
						</div>
					</div>

					<div class="card-body">
						<div class="row">
							<div class="col-12">
								<p class="lead"><small>* The physical gold balance is processing to be delivered to your
										domicile.</small></p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div> -->

		<!-- Account Level FM, IB, LP  -->
		<div v-if="accountLevel == 'fm' || accountLevel == 'ib' || accountLevel == 'lp'" class="row">
			<div class="col-12 table-responsive p-0">
				<table class="table table--report text-nowrap">
					<thead style="background-color: #0f0f17">
						<tr class="text-center">
							<th>HIN</th>
							<th>ACCOUNT</th>
							<th>PRODUCT</th>
							<th>HUB</th>
							<th>QTY</th>
							<th>TOTAL <br> GRAM</th>
							<th>AVERAGE <br> METAL COST</th>
							<th>FEE & <br> TAX</th>
							<th>AVERAGE TOTAL <br> COST INC. FEES & TAX</th>
							<th>METAL VALUE <br> AT DATE</th>
							<th v-if="accountLevel != 'lp'">ESTIMATED <br> P & L</th>
						</tr>
					</thead>
					<tbody>
						<template v-if="holdingsStatus == 'error'">
							<tr>
								<td class="text-center" colspan="11">
									<h4>FAILED TO RETRIEVE DATA</h4>
									<br />
									<!-- <button class="btn c-btn-theme" @click="setHoldings()">Try Again</button> -->
									<button class="btn c-btn-theme" @click="setNewHoldingsPbIb()">Try Again</button>
								</td>
							</tr>
						</template>
						<template v-else-if="holdingsStatus != 'loading'">
							<tr v-for="holding in holdings" v-bind:key="holding.id">
								<td class="text-center">
									<Loader v-if="holding.hin == 'loadingTemp'" size_prop="14px" borderSize_prop="1px"></Loader>

									<template v-else>
										{{ holding.hin }}
									</template>
								</td>
								<td class="text-center">
									<Loader v-if="holding.account == 'loadingTemp'" size_prop="14px" borderSize_prop="1px"></Loader>

									<template v-else>
										{{ accountLevel == 'lp' ? 'Liquidity Provider' : holding.account }}
									</template>
								</td>
								<td class="text-center">{{ holding.product }}</td>
								<td class="text-center">JAK</td>
								<td class="text-center">{{ Decimal.div(holding.quantity,
									$store.getters.getContractConfigs(holding.contractId).weightCorrection).toFixed(2) }}</td>
								<td class="text-center">{{ numberFormatExtend((holding.totalGram)) }}</td>

								<td class="text-right">{{ isNaN(holding.averageMetalCostUsd) ? '-' : (currency == 'usd') ?
									numberFormatExtend(holding.averageMetalCostUsd.toFixed(2)) :
									numberFormatExtend(holding.averageMetalCostIdr.toFixed(2)) }}</td>

								<td class="text-right">{{ isNaN(holding.totalFeeAndTaxUsd) ? '-' : (currency == 'usd') ?
									numberFormatExtend(holding.totalFeeAndTaxUsd.toFixed(3), 3) :
									numberFormatExtend(holding.totalFeeAndTaxIdr.toFixed(2)) }}</td>

								<td class="text-right">{{ isNaN(holding.averageTotalCostIncFeeAndTaxUsd) ? '-' : (currency == 'usd') ?
									numberFormatExtend(holding.averageTotalCostIncFeeAndTaxUsd.toFixed(2)) :
									numberFormatExtend(holding.averageTotalCostIncFeeAndTaxIdr.toFixed(2)) }}</td>

								<td class="text-right">{{ metalValueAtDateShown(holding) }}</td>

								<td v-if="clientChosed == 'lp'" class="text-center">
									<div v-if="Number((holding.totalGram)) >= 10000"
										class="alert alert-primary py-0 px-2 m-0 d-inline-block font-weight-bold" role="alert"
										style="background-color: #2EC4B6;">
										Active
									</div>

									<div v-if="Number((holding.totalGram)) >= 5000 && Number((holding.totalGram)) < 10000"
										class="alert alert-primary py-0 px-2 m-0 d-inline-block font-weight-bold" role="alert"
										style="background-color: orange;">
										Consider
									</div>

									<div v-if="Number((holding.totalGram)) < 5000"
										class="alert alert-primary py-0 px-2 m-0 d-inline-block font-weight-bold" role="alert"
										style="background-color: #E71D36;">
										Suspended
									</div>
								</td>

								<td v-else-if="accountLevel != 'lp'" class="text-right">{{ estimatePnlShown(holding) }} {{
									estimatePnlPercentageShown(holding) }}</td>
							</tr>
							<tr v-if="holdings.length < 1">
								<td colspan="11" class="text-center">No data available in table</td>
							</tr>
						</template>
						<template v-else>
							<tr>
								<td class="text-center" colspan="11">
									<Loader size_prop="10em"></Loader>
								</td>
							</tr>
						</template>
					</tbody>
					<tfoot>

					</tfoot>
				</table>
			</div>
		</div>

		<!-- Account Level Client -->
		<!-- <div v-if="accountLevel == 'client'" class="row">
			<div class="col-12 table-responsive p-0">
				<table class="table table--report text-nowrap">
					<thead style="background-color: #0f0f17">
						<tr class="text-center">
							<th>HIN</th>
							<th>ACCOUNT</th>
							<th>PRODUCT</th>
							<th>HUB</th>
							<th>QTY</th>
							<th>TOTAL <br> GRAM</th>
							<th>AVERAGE <br> METAL COST</th>
							<th>FEE & <br> TAX</th>
							<th>AVERAGE TOTAL <br> COST INC. FEES & TAX</th>
							<th>METAL VALUE <br> AT DATE</th>
							<th>ESTIMATED <br> P & L</th>
						</tr>
					</thead>
					<tbody>
						<template v-if="holdingsStatus == 'error'">
							<tr>
								<td class="text-center" colspan="11">
									<h4>FAILED TO RETRIEVE DATA</h4>
									<br />
									<button class="btn c-btn-theme" @click="setNewHoldings()">Try Again</button>
								</td>
							</tr>
						</template>
						<template v-if="holdingsStatus != 'loading'">
							<tr v-for="holding in newHoldings" v-bind:key="'holding' + holding.contract_id">
								<td class="text-center">
									{{ holding.hin }}
								</td>

								<td class="text-center">
									{{ holding.account }}
								</td>

								<td class="text-center">
									{{ $store.getters.getContractConfigs(holding.contract_id).name }}
								</td>

								<td class="text-center">JAK</td>

								<td class="text-center">
									{{ Decimal.div(holding.quantity,
										$store.getters.getContractConfigs(holding.contract_id).weightCorrection).toFixed(2) }}
								</td>

								<td class="text-center">
									{{ numberFormatExtend(Decimal.div(holding.quantity,
										$store.getters.getContractConfigs(holding.contract_id).weightCorrection).times($store.getters.getContractConfigs(holding.contract_id).weightInGram).toFixed(2))
									}}
								</td>

								<td class="text-right">{{ holding.avg_metal_cost != null ? (currency == 'usd') ?
									numberFormatExtend((holding.avg_metal_cost).toFixed(2)) :
									numberFormatExtend(holding.avg_metal_cost_idr.toFixed(2)) : '-' }}</td>

								<td class="text-right">{{ (currency == 'usd') ?
									numberFormatExtend(holding.fee_tax.toFixed(3), 3) :
									numberFormatExtend(holding.fee_tax_idr.toFixed(2)) }}
								</td>

								<td class="text-right">{{ holding.avg_metal_cost != null ? (currency == 'usd') ?
									numberFormatExtend((holding.avg_total_cost).toFixed(2)) :
									numberFormatExtend(holding.avg_total_cost_idr.toFixed(2)) : '-' }}</td>

								<td class="text-right">{{ metalValueAtDateShown(holding) }}</td>

								<td v-if="clientChosed == 'lp'" class="text-center">
									<div v-if="Number((holding.totalGram)) >= 10000"
										class="alert alert-primary py-0 px-2 m-0 d-inline-block font-weight-bold" role="alert"
										style="background-color: #2EC4B6;">
										Active
									</div>

									<div v-if="Number((holding.totalGram)) >= 5000 && Number((holding.totalGram)) < 10000"
										class="alert alert-primary py-0 px-2 m-0 d-inline-block font-weight-bold" role="alert"
										style="background-color: orange;">
										Consider
									</div>

									<div v-if="Number((holding.totalGram)) < 5000"
										class="alert alert-primary py-0 px-2 m-0 d-inline-block font-weight-bold" role="alert"
										style="background-color: #E71D36;">
										Suspended
									</div>
								</td>

								<td v-else class="text-right">{{ estimatePnlShown(holding) }} {{ estimatePnlPercentageShown(holding)
								}}</td>
							</tr>
							<tr v-if="newHoldings.length < 1">
								<td colspan="11" class="text-center">No data available in table</td>
							</tr>
						</template>
						<template v-else>
							<tr>
								<td class="text-center" colspan="11">
									<Loader size_prop="10em"></Loader>
								</td>
							</tr>
						</template>
					</tbody>
					<tfoot>

					</tfoot>
				</table>
			</div>
		</div> -->

		<div class="row" v-if="accountLevel == 'fm' || accountLevel == 'ib' || this.accountLevel == 'lp'">
			<div class="col">
				<Pagination2 :totalData_prop="totalHoldings" @changePage="setNewHoldingsPbIb">
				</Pagination2>
			</div>
		</div>

		<!-- <div v-if="$store.getters.paymentMethod == 'gopay'" class="bg-grey-1 text-white text-xs rounded-lg p-6">
			<div class="text-base font-bold mb-3">Penarikan Emas</div>

			<div class="mb-3">
				Penarikan emas fisik dapat Anda lakukan dengan mengisi form yang tersedia. Lalu ikuti langkah berikutnya
			</div>

			<div>
				<button class="btn bg-theme text-xs w-24 h-8">Isi Form</button>
			</div>
		</div> -->

		<TradeTicket ref="tradeTicketRef" @afterTradeSuccess="afterTradeSuccess" :contractId_prop="tradeTicket.contractId"
			:gold_id_props="tradeTicket.goldId" :product_is_active_prop="tradeTicket.productIsActive"
			:ticker_prop="tradeTicket.ticker" :name="tradeTicket.name" :weight="tradeTicket.weight"
			:weightCorection_prop="tradeTicket.weightCorrection" :openSellOrders_prop="openSellOrders"
			:directionDefault_prop="tradeTicket.direction">
		</TradeTicket>
	</div>
</template>

<script>
import axios, { abortController } from '@/api/axios.js'
import { Decimal } from 'decimal.js'
import TradingFormula, { currencyFormat } from '@bei/trading-formula'

import holdingsMixin from '@/composable/holdingsMixin.js'
import Utils from '@/utils/index.js'

import HoldingContract from './HoldingContract.vue'
import IconEyeClose from '@/components/icons/IconEyeClose.vue'
import IconEyeOpen from '@/components/icons/IconEyeOpen.vue'
import ReportsNav from '@/components/reports/ReportsNav.vue'
import Pagination2 from '@/components/Pagination2.vue'
import Loader from '@/components/Loader.vue'
import TradeTicket from '@/components/TradeTicket.vue'
import ShimmerLoader from '../../ShimmerLoader.vue'
import Tooltip from '@/components/Tooltip.vue'

export default {
	name: 'Holdings',

	mixins: [holdingsMixin],

	components: {
		HoldingContract,
		IconEyeClose,
		IconEyeOpen,
		ReportsNav,
		Pagination2,
		Loader,
		TradeTicket,
		ShimmerLoader,
		Tooltip
	},

	data() {
		return {
			Decimal: Decimal,

			hexColorTheme: getComputedStyle(document.documentElement).getPropertyValue('--color-theme'),

			callSetHoldingFrom: 'created', //created || watch
			holdings: [],
			newHoldings: [],
			totalHoldings: 1,
			holdingsPageIndex: 0,
			holdingsStatus: 'loading',

			selectedClientHolding: 'all',

			clientChosed: 'all',

			totalGoldLp: new Decimal(0),

			dataShown: 'holding', // holding || realized,

			tradeTicket: {
				goldId: '',
				productId: '',
				name: '',
				weight: 0,
				buyPrice: 0,
				sellPrice: 0,
				contractId: '',
				direction: 'buy',
			},
			openSellOrders: {},
		}
	},

	computed: {
		showHolding() {
			return this.$store.state.goldBalanceNew.showHolding
		},

		currency() {
			return this.$store.state.currency
		},

		accountLevel() {
			return this.$store.getters.getAccountLevel
		},

		products() {
			return this.$store.getters.PRODUCTS
		},

		contractsTemp() {
			return this.$store.state.contracts
		},

		hubsTemp() {
			return this.$store.state.hubs
		},

		// reservedGold() {
		// 	return this.$store.getters.getReservedGold
		// },

		streamingRate() {
			return this.$store.getters.getStreamingRate
		},

		streamingRateBuy() {
			if (this.currency == 'idr') {
				return this.streamingRate.streamBuy
			} else {
				return 1
			}
		},

		streamingRateSell() {
			if (this.currency == 'idr') {
				return this.streamingRate.streamSell
			} else {
				return 1
			}
		},

		listClients() {
			return this.$parent.listClients
		},

		sumMetalValueAtDateAllContract() {
			let sumMetalValue = new Decimal(0)

			this.goldBalances.forEach((goldBalance) => {
				sumMetalValue = sumMetalValue.plus(this.countMetalValueAtDateNew(goldBalance.contract_id, goldBalance.remaining_quantity))
			})

			return sumMetalValue.toNumber()
		},

		sumMetalValueAtDateAllContractShown() {
			let sumMetalValue = new Decimal(this.sumMetalValueAtDateAllContract)

			const fractionDigits = this.currency == 'idr' ? this.$store.state.fractionDigit.idr : this.$store.state.fractionDigit.usd
			return this.currencySymbol + Utils.currencyFormat(sumMetalValue.toFixed(fractionDigits), this.currency)
		},

		sumUnrealizedPnlAllContract() {
			let sumPnl = new Decimal(0)
			this.goldBalances.forEach((goldBalance) => {
				sumPnl = sumPnl.plus(this.countUnrealizedPnl(goldBalance))
			})

			return sumPnl.toNumber()
		},

		sumUnrealizedPnlAllContractShown() {
			const sumPnl = new Decimal(this.sumUnrealizedPnlAllContract)

			let sign = ''
			if (sumPnl.lessThan(0)) {
				sign = '-'
			} else if (sumPnl.greaterThan(0)) {
				sign = '+'
			}

			const fractionDigits = this.currency == 'idr' ? this.$store.state.fractionDigit.idr : this.$store.state.fractionDigit.usd
			return `${sign}${this.currencySymbol}${Utils.currencyFormat(sumPnl.abs().toFixed(fractionDigits), this.currency)}`
		},

		sumPercentageUnrealizedPnlAllContract() {
			let sumPnl = new Decimal(this.sumUnrealizedPnlAllContract)

			let sumBuy = new Decimal(0)
			this.goldBalances.forEach((goldBalance) => {
				const totalPriceBuy = this.currency == 'idr' ? goldBalance.remaining_cost_idr : goldBalance.remaining_cost_usd
				sumBuy = sumBuy.plus(totalPriceBuy)
			})

			if (sumBuy.equals(0)) {
				return '(0%)'
			}

			const percentage = sumPnl.dividedBy(sumBuy).times(100)

			let sign = '+'
			if (percentage.lessThan(0)) {
				sign = '-'
			}

			return `(${sign}${percentage.abs().toFixed(2)}%)`
		},

		sumNominalDiterimaAllContract() {
			let sum = new Decimal(0)
			this.$store.state.goldBalanceNew.goldBalanceNew.forEach((holding) => {
				sum = sum.plus(this.currency == 'idr' ? new Decimal(holding.sold_amount_idr) : new Decimal(holding.sold_amount_usd))
			})

			const fractionDigits = this.currency == 'idr' ? this.$store.state.fractionDigit.idr : this.$store.state.fractionDigit.usd
			return sum.toFixed(fractionDigits)
		},
		sumNominalDiterimaAllContractShown() {
			const sum = this.sumNominalDiterimaAllContract

			const fractionDigits = this.currency == 'idr' ? this.$store.state.fractionDigit.idr : this.$store.state.fractionDigit.usd
			return `${this.currencySymbol}` + Utils.currencyFormat(new Decimal(sum).abs().toFixed(fractionDigits), this.currency)
		},

		sumRealizedPnlAllContract() {
			let sum = new Decimal(0)
			this.$store.state.goldBalanceNew.goldBalanceNew.forEach((holding) => {
				sum = sum.plus(this.countRealizedPnl(holding))
			})

			const fractionDigits = this.currency == 'idr' ? this.$store.state.fractionDigit.idr : this.$store.state.fractionDigit.usd
			return sum.toFixed(fractionDigits)
		},
		sumRealizedPnlAllContractShown() {
			const sum = this.sumRealizedPnlAllContract

			let sign = ''
			if (new Decimal(sum).greaterThan(0)) {
				sign = '+'
			} else if (new Decimal(sum).lessThan(0)) {
				sign = '-'
			}

			const fractionDigits = this.currency == 'idr' ? this.$store.state.fractionDigit.idr : this.$store.state.fractionDigit.usd
			return `${sign}${this.currencySymbol}` + Utils.currencyFormat(new Decimal(sum).abs().toFixed(fractionDigits), this.currency)
		},

		sumPercentageRealizedPnlAllContract() {
			const sumSell = this.sumNominalDiterimaAllContract
			const sumPnl = this.sumRealizedPnlAllContract
			const sumBuy = Decimal.sub(sumSell, sumPnl)

			if (new Decimal(sumBuy).equals(0)) {
				return '(0%)'
			}

			const percentage = Decimal.div(sumPnl, sumBuy).times(100)

			let sign = '+'
			if (new Decimal(percentage).lessThan(0)) {
				sign = '-'
			}

			return ` (${sign}${new Decimal(percentage).abs().toFixed(2)}%)`
		},

		sumGramHoldingAllContract() {
			let sum = new Decimal(0)
			this.$store.state.goldBalanceNew.goldBalanceNew.forEach((holding) => {
				sum = sum.plus(new Decimal(holding.remaining_quantity))
			})

			return sum.toFixed(2)
		},

		sumGramSoldAllContract() {
			let sum = new Decimal(0)
			this.$store.state.goldBalanceNew.goldBalanceNew.forEach((holding) => {
				sum = sum.plus(new Decimal(holding.sold_quantity))
			})

			return sum.toFixed(2)
		},
	},

	created() {
		this.$store.dispatch('setHoldings')

		const firstCall = setInterval(() => {
			if (this.products && this.contractsTemp && this.accountLevel && this.hubsTemp) {

				// this.orderFilterStatusSubmit()
				// this.setTransactions()

				if (this.accountLevel == 'ib' || this.accountLevel == 'fm' || this.accountLevel == 'lp') {
					clearInterval(firstCall)

					this.setNewHoldingsPbIb()
				}
			}
		}, 1000)

		this.setOpenSellOrders()
		console.log('Holdings created', this.$store.state.golds)
	},

	methods: {
		changeDataShown(newValue) {
			this.dataShown = newValue
		},

		afterTradeSuccess() {
			this.$emit('afterTradeSuccess')
		},

		async setNewHoldings(skip = 0, limit = 10) {
			let contractsParam = ''
			for (let key in this.$store.state.contractIds) {
				contractsParam = contractsParam + `contract_id[]=${this.$store.state.contractIds[key]}&`
			}

			if (this.callSetHoldingFrom != 'watch') {
				this.holdingsStatus = 'loading'
			}

			try {
				const response = await this.$store.dispatch('setHoldings', {
					skip: skip,
					limit: limit,
					selectedClientHolding: this.selectedClientHolding,
				})

				// sort holdings based on sequence on config
				const holdingsAfterSequence = (holdingsParam) => {
					let holdingsAfter = []
					this.$store.state.holdingsSequence.forEach(element => {
						const temp = holdingsParam.find(obj => obj.contract_id == element)
						if (temp) {
							holdingsAfter.push(temp)
						}
					})

					return holdingsAfter
				}

				this.newHoldings = []
				let tempData = holdingsAfterSequence(response.data.data.body)
				for (let i = 0; i < tempData.length; i++) {
					if (tempData[i].contract_id != 0 && tempData[i].quantity != 0) {

						// the response's structure is different between client and fm/ib accocunt. Client: 'contract_id'; FM/IB: 'contractId' ¯\(°_o)/¯ 
						if (this.accountLevel == 'fm' || this.accountLevel == 'ib') {
							this.$set(tempData, 'contract_id', tempData.attributes.contractId)
						}

					}

					// Buat Saskia QA. Dev only
					if (process.env.NODE_ENV == 'development') {

						const contractConfig = this.$store.getters.getContractConfigs(tempData[i].contract_id)
						const gold = this.$store.state.golds[tempData[i].contract_id]

						const metalValueAtDateUsd = this.$store.getters.getMetalValueAtDateUsdByContractId(tempData[i].contract_id)
						const metalValueAtDateIdr = this.$store.getters.getMetalValueAtDateIdrByContractId(tempData[i].contract_id)

						const pnlUsd = this.$store.getters.getEstimatePNLUsdByContractId(tempData[i].contract_id)
						const pnlIdr = this.$store.getters.getEstimatePNLIdrByContractId(tempData[i].contract_id)

						// console.image("https://www.google.com/url?sa=i&url=https%3A%2F%2Fwww.teenvogue.com%2Fstory%2Fbts-jungkook-covid-19-grammys-2022&psig=AOvVaw37Z04fj8onphzNe5teznGO&ust=1709974039914000&source=images&cd=vfe&opi=89978449&ved=0CBMQjRxqFwoTCNDO1-yj5IQDFQAAAAAdAAAAABAI");

						const style = 'background-color: darkblue; color: white; font-style: italic; border: 5px solid hotpink; font-size: 2em;'
						console.log("%c🤔🤔🤔", style,
							"\n\n",
							"Kontrak: ", contractConfig.name,
							"\n\n",
							"Quantity: ", Decimal.div(tempData[i].quantity, contractConfig.weightCorrection).toNumber(),
							"\n",
							"Total Gram: ", Decimal.div(tempData[i].quantity, contractConfig.weightCorrection).times(contractConfig.weightInGram).toNumber(),
							"\n\n",
							"Average Metal Cost USD: ", this.numberFormatExtend(tempData[i].avg_metal_cost),
							"\n",
							"Average Metal Cost IDR: ", this.numberFormatExtend(tempData[i].avg_metal_cost_idr),
							"\n\n",
							"Fee & Tax USD: ", this.numberFormatExtend(tempData[i].fee_tax, 3),
							"\n",
							"Fee & Tax IDR: ", this.numberFormatExtend(tempData[i].fee_tax_idr),
							"\n\n",
							"Average Total Cost Inc FEE and TAX USD: ", this.numberFormatExtend(tempData[i].avg_total_cost),
							"\n",
							"Average Total Cost Inc FEE and TAX IDR: ", this.numberFormatExtend(tempData[i].avg_total_cost_idr),
							"\n\n",
							"Metal Value at Date USD: ", this.numberFormatExtend(metalValueAtDateUsd.toNumber()),
							"\n",
							"Metal Value at Date IDR: ", this.numberFormatExtend(metalValueAtDateIdr.toNumber()),
							"\n\n",
							"PnL USD: ", this.numberFormatExtend(pnlUsd.toNumber()),
							"\n",
							"PnL IDR: ", this.numberFormatExtend(pnlIdr.toNumber()),
							"\n\n",
							"PnL Percentage USD: ", this.numberFormatExtend(Decimal.div(pnlUsd, tempData[i].avg_total_cost).times(100).toNumber()),
							"\n",
							"PnL Percentage IDR: ", this.numberFormatExtend(Decimal.div(pnlIdr, tempData[i].avg_total_cost_idr).times(100).toNumber()),
							"\n\n",
							"Harga JUAL USD: ", gold.sell,
							"\n",
							"Harga JUAL IDR: ", Decimal.mul(gold.sell, this.streamingRate.streamSell).toNumber(),
							"\n\n",
							"Harga BELI USD: ", gold.buy,
							"\n",
							"Harga BELI IDR: ", Decimal.mul(gold.buy, this.streamingRate.streamSell).toNumber(),
						)
					}
				}
				this.newHoldings = tempData

				this.holdingsStatus = 'idle'

			} catch (error) {
				this.holdingsStatus = 'error'

				console.error('Gagal set new holdings', error.config)
			}
		},

		async setNewHoldingsPbIb(skip = 0, limit = 10) {
			this.holdingsStatus = 'loading'

			let contractsParam = ''
			if (this.accountLevel == 'lp') {
				for (let key in this.$store.state.contractIds) {
					contractsParam = contractsParam + `contract_id[]=${this.$store.state.contractIds[key]}&`
				}
			} else {
				for (let key in this.$store.state.contractIds) {
					contractsParam = contractsParam + `contractId[]=${this.$store.state.contractIds[key]}&`
				}
			}

			this.clientChosed = 'all'

			let urlApiHoldings = ''
			let urlApiTransactions = ''
			if (this.accountLevel == 'ib' || this.accountLevel == 'fm' || this.accountLevel == 'ccp') {
				if (this.selectedClientHolding == 'all') {
					urlApiTransactions = '/v2/rrs/transactions?' + contractsParam + 'date_start=&date_end='

					urlApiHoldings = '/v2/rrs/holdings?hin=' + this.$store.getters.getHin + '&offset=' + skip + '&limit=' + limit
				} else {
					if (this.accountLevel == 'fm') {
						urlApiTransactions = '/v2/rrs/transactions?hin=' + this.selectedClientHolding.attributes.hin + '&accountId=' + this.selectedClientHolding.id + '&' + contractsParam + 'date_start=&date_end='

						urlApiHoldings = '/v2/rrs/holdings?hin=' + this.selectedClientHolding.attributes.hin + '&accountId=' + this.selectedClientHolding.id
					} else {
						urlApiTransactions = '/v2/rrs/transactions?hin=' + this.selectedClientHolding.trade_account.hin + '&accountId=' + this.selectedClientHolding.trade_account.account_id + '&' + contractsParam + 'date_start=&date_end='

						urlApiHoldings = '/v2/rrs/holdings?hin=' + this.selectedClientHolding.trade_account.hin + '&accountId=' + this.selectedClientHolding.trade_account.account_id
					}

					if (this.selectedClientHolding.trade_account.hin.substring(0, 2).toLowerCase() == 'lp') {
						this.clientChosed = 'lp'
					}
				}
			} else if (this.accountLevel == 'lp') {
				urlApiTransactions = '/v2/igx/market-maker/transaction?' + contractsParam + 'date_start=&date_end='

				urlApiHoldings = '/v2/igx/market-maker/holding'
			}
			else {
				urlApiTransactions = '/v2/igx/transactions?' + contractsParam + 'date_start=&date_end='

				urlApiHoldings = '/v2/igx/holding'
			}

			let resHoldings
			try {
				resHoldings = await axios.post(urlApiHoldings, {
					user_id: this.$store.state.userId
				})
			} catch (error) {
				this.holdingsStatus = 'error'
				return
			}

			this.holdingsPageIndex = 0
			this.holdings = []
			let responseHoldings = resHoldings.data.data.body

			if (this.accountLevel == 'fm' || this.accountLevel == 'ib' || this.accountLevel == 'lp') {
				responseHoldings = resHoldings.data.data.body
				this.totalHoldings = resHoldings.data.data.count
			}

			if (responseHoldings.length < 1) {
				this.holdingsStatus = 'idle'
			}

			// let sortedHoldings = responseHoldings.sort((a, b) => (a.attributes.accountId > b.attributes.accountId) ? 1 : ((b.attributes.accountId > a.attributes.accountId) ? -1 : 0))

			const flatenedHoldings = responseHoldings.flatMap(item => {
				return item.holdings.map(holding => {
					const contractConfig = this.$store.getters.getContractConfigs(holding.contract_id)

					// if quantity 0, return null
					if (holding.quantity == 0 || holding.contract_id == 0) {
						return null
					}

					return {
						id: item.account_id + '-' + holding.contract_id, // unique id for v-for
						contractId: holding.contract_id,
						hin: item.hin,
						account: item.account,
						product: contractConfig.name,
						hub: holding.hub,
						quantity: new Decimal(holding.quantity),
						quantityShown: Decimal.div(holding.quantity, contractConfig.weightCorrection),
						totalGram: Decimal.mul(contractConfig.weightInGram, holding.quantity).toNumber(),
						averageMetalCostUsd: holding.avg_metal_cost,
						averageMetalCostIdr: holding.avg_metal_cost_idr,
						totalFeeAndTaxUsd: holding.fee_tax,
						totalFeeAndTaxIdr: holding.fee_tax_idr,
						averageTotalCostIncFeeAndTaxUsd: holding.avg_total_cost,
						averageTotalCostIncFeeAndTaxIdr: holding.avg_total_cost_idr,
						totalQuantity: holding.quantity
					}
				})
			})

			// filter null values and set to holdings
			this.holdings = flatenedHoldings.filter(item => item !== null)
			this.holdingsStatus = 'idle'
		},

		countMetalValueAtDate(holding) {
			let contractId
			if (this.accountLevel == 'fm' || this.accountLevel == 'ib' || this.accountLevel == 'lp') {
				contractId = holding.contractId
			} else {
				contractId = holding.contract_id
			}

			if (this.currency == 'usd') {
				const temp = this.$store.getters.getMetalValueAtDateUsdByContractId(contractId)
				return temp
			} else {
				const temp = this.$store.getters.getMetalValueAtDateIdrByContractId(contractId)
				return temp
			}
		},
		metalValueAtDateShown(holding) {
			// const metalValueAtDate = this.countMetalValueAtDate(holding)
			// if (metalValueAtDate.lessThan(0)) {
			// 	return '-'
			// }

			// return this.numberFormatExtend(metalValueAtDate.toFixed(2))

			if (this.streamingRate.streamSell == -1 && this.currency != 'usd') {
				return '-'
			}

			let contractId
			if (this.accountLevel == 'fm' || this.accountLevel == 'ib' || this.accountLevel == 'lp') {
				contractId = holding.contractId
			} else {
				contractId = holding.contract_id
			}

			if (!this.$store.state.golds[contractId]) {
				return '-'
			}

			const contractPriceUsd = this.$store.state.golds[contractId].originalContractPriceSell

			const rate = this.streamingRate.streamSell

			const tempMva = TradingFormula.reports.holdings.getMetalValueAtDate({
				contractPriceUsd: contractPriceUsd,
				quantity: holding.quantity,
				currency: this.currency,
				rate: rate,
				contractId: contractId
			})

			return currencyFormat(tempMva)
		},

		countEstimatePnl(holding) {
			// let contractId
			// if (this.accountLevel == 'fm' || this.accountLevel == 'ib' || this.accountLevel == 'lp') {
			// 	contractId = holding.contractId
			// } else {
			// 	contractId = holding.contract_id
			// }

			// if (this.currency == 'usd') {
			// 	return this.$store.getters.getEstimatePNLUsdByContractId(contractId)
			// } else {
			// 	return this.$store.getters.getEstimatePNLIdrByContractId(contractId)
			// }

			if (this.streamingRate.streamSell == -1 && this.currency != 'usd') {
				return '-'
			}

			let contractId
			if (this.accountLevel == 'fm' || this.accountLevel == 'ib' || this.accountLevel == 'lp') {
				contractId = holding.contractId
			} else {
				contractId = holding.contract_id
			}

			if (!this.$store.state.golds[contractId]) {
				return '-'
			}

			const contractPriceUsd = this.$store.state.golds[contractId].originalContractPriceSell

			let averageTotalCostIncFeeAndTax
			if (this.accountLevel == 'fm' || this.accountLevel == 'ib') {
				if (this.currency == 'usd') {
					averageTotalCostIncFeeAndTax = holding.averageTotalCostIncFeeAndTaxUsd
				} else {
					averageTotalCostIncFeeAndTax = holding.averageTotalCostIncFeeAndTaxIdr
				}
			} else {
				if (this.currency == 'usd') {
					averageTotalCostIncFeeAndTax = holding.avg_total_cost
				} else {
					averageTotalCostIncFeeAndTax = holding.avg_total_cost_idr
				}
			}

			const rate = this.streamingRate.streamSell

			const tempPnl = TradingFormula.reports.holdings.getEstimatePnl({
				contractPriceUsd: contractPriceUsd,
				averageTotalCostIncFeeAndTax: averageTotalCostIncFeeAndTax,
				quantity: holding.quantity,
				currency: this.currency,
				rate: rate
			})

			return tempPnl
		},
		estimatePnlShown(holding) {
			// const estimatePnl = this.countEstimatePnl(holding)
			// if (estimatePnl == '-') {
			// 	return '-'
			// }

			// return this.numberFormatExtend(estimatePnl.toFixed(2))

			const estimatePnl = this.countEstimatePnl(holding)

			if (estimatePnl == '-') {
				return '-'
			}

			if (estimatePnl == 0) {
				return 0
			}

			return currencyFormat(estimatePnl)
		},

		countEstimatePNLPercentage(holding) {
			// const estimatePnl = this.countEstimatePnl(holding)
			// if (estimatePnl == '-') {
			// 	return '-'
			// }

			// let tempAMC
			// if (this.accountLevel == 'fm' || this.accountLevel == 'ib') {
			// 	tempAMC = this.currency == 'usd' ? holding.averageTotalCostIncFeeAndTaxUsd : holding.averageTotalCostIncFeeAndTaxIdr
			// } else {
			// 	tempAMC = this.currency == 'usd' ? holding.avg_total_cost : holding.avg_total_cost_idr
			// }

			// if (tempAMC == 0) {
			// 	return new Decimal(0)
			// }

			// return Decimal.div(estimatePnl, (tempAMC)).times(100).toFixed(2)
		},
		estimatePnlPercentageShown(holding) {
			// let tempAMC
			// if (this.accountLevel == 'fm' || this.accountLevel == 'ib') {
			// 	tempAMC = this.currency == 'usd' ? holding.averageTotalCostIncFeeAndTaxUsd : holding.averageTotalCostIncFeeAndTaxIdr
			// } else {
			// 	tempAMC = this.currency == 'usd' ? holding.avg_total_cost : holding.avg_total_cost_idr
			// }

			// const metalValueAtDate = this.countMetalValueAtDate(holding)
			// if (metalValueAtDate.lessThan(0) || isNaN(tempAMC)) {
			// 	return '-'
			// }

			// const estimatePnlPercentage = this.countEstimatePNLPercentage(holding)
			// return '(' + estimatePnlPercentage + ')%'

			const estimatePnl = this.countEstimatePnl(holding)

			if (estimatePnl === '-') {
				return '-'
			}

			if (estimatePnl == 0) {
				return '(0)%'
			}

			let averageTotalCostIncFeeAndTax
			if (this.accountLevel == 'fm' || this.accountLevel == 'ib') {
				if (this.currency == 'usd') {
					averageTotalCostIncFeeAndTax = holding.averageTotalCostIncFeeAndTaxUsd
				} else {
					averageTotalCostIncFeeAndTax = holding.averageTotalCostIncFeeAndTaxIdr
				}
			} else {
				if (this.currency == 'usd') {
					averageTotalCostIncFeeAndTax = holding.avg_total_cost
				} else {
					averageTotalCostIncFeeAndTax = holding.avg_total_cost_idr
				}
			}

			const estimatePnlPercentage = TradingFormula.reports.holdings.getEstimatePnlPercentage({
				averageTotalCostIncFeeAndTax: averageTotalCostIncFeeAndTax,
				estimatePnl: estimatePnl
			})

			return '(' + estimatePnlPercentage + ')%'
		},

		changeFilterClientHolding(clientData) {
			this.selectedClientHolding = clientData
			if (this.accountLevel == 'ib' || this.accountLevel == 'fm' || this.accountLevel == 'lp') {
				// this.setHoldings()
				this.setNewHoldingsPbIb()
			} else {
				this.setNewHoldings()
			}
		},

		updateTradeTicket(contractId, direction) {
			const contract = this.contractsTemp.find((obj) => obj.id == contractId)
			const contractConfig = this.$store.getters.getContractConfigs(contractId)

			let tradeTicketTemp = {}

			tradeTicketTemp.name = contractConfig.tradeTicketName
			tradeTicketTemp.weight = contractConfig.weightInGram
			tradeTicketTemp.ticker = contract.attributes.ticker
			tradeTicketTemp.direction = direction

			if (!contract) {
				tradeTicketTemp.goldId = '0'
				tradeTicketTemp.productIsActive = false
				tradeTicketTemp.weight = 0
			} else {
				tradeTicketTemp.ticker = contract.attributes.ticker
				tradeTicketTemp.productIsActive = contract.attributes.contractStatusId
				tradeTicketTemp.goldId = String(contractId)
				tradeTicketTemp.weightCorrection = contractConfig.weightCorrection
				tradeTicketTemp.contractId = contract.id
			}

			this.tradeTicket = tradeTicketTemp
			this.$refs.tradeTicketRef.openTradeTicket()
		},

		setOpenSellOrders() {
			const listContract = this.$store.state.contractIds
			let contractParam = ''
			for (let key in listContract) {
				contractParam += 'contractId[]=' + listContract[key] + '&'
			}

			axios
				.post('/v2/igx/orders?order_type=limit&' + contractParam + 'status=submit', {
					user_id: this.$store.state.userId,
				})
				.then((response) => {
					if (!response.data.data.body) {
						return
					}

					const orders = response.data.data.body.filter((obj) => obj.attributes.direction == 'sell')

					const uniqueContract = [...new Set(orders.map((obj) => obj.attributes.contractId))]

					let temp = {}
					for (let i = 0; i < uniqueContract.length; i++) {
						const orderWithId = orders.filter((obj) => obj.attributes.contractId == uniqueContract[i])

						let quantityTemp = 0
						orderWithId.forEach((order) => {
							quantityTemp += Decimal.div(order.attributes.quantity, this.$store.getters.getContractConfigs(uniqueContract[i]).weightCorrection).toNumber()
						})

						this.$set(temp, uniqueContract[i], quantityTemp)
					}

					// const temp = {
					//   [this.$store.state.contractIds.contract_100g]: orders.filter(obj => obj.attributes.contractId == this.$store.state.contractIds.contract_100g),
					//   [this.$store.state.contractIds.contract_1kg]: orders.filter(obj => obj.attributes.contractId == this.$store.state.contractIds.contract_1kg),
					//   [this.$store.state.contractIds.contract_1g]: orders.filter(obj => obj.attributes.contractId == this.$store.state.contractIds.contract_1g),
					//   [this.$store.state.contractIds.contract_001g]: orders.filter(obj => obj.attributes.contractId == this.$store.state.contractIds.contract_001g)
					// }

					this.openSellOrders = temp
				})
				.catch((error) => {
					console.error(error.message)
				})
		},

		// async setHoldings(skip = 0, limit = 10) {
		// 	this.holdingsStatus = 'loading'

		// 	let hubs = this.hubsTemp
		// 	let contracts = this.contractsTemp

		// 	let contractsParam = ''
		// 	if (this.accountLevel == 'lp') {
		// 		for (let key in this.$store.state.contractIds) {
		// 			contractsParam = contractsParam + `contract_id[]=${this.$store.state.contractIds[key]}&`
		// 		}
		// 	} else {
		// 		for (let key in this.$store.state.contractIds) {
		// 			contractsParam = contractsParam + `contractId[]=${this.$store.state.contractIds[key]}&`
		// 		}
		// 	}

		// 	this.clientChosed = 'all'

		// 	let urlApiHoldings = ''
		// 	let urlApiTransactions = ''
		// 	if (this.accountLevel == 'ib' || this.accountLevel == 'fm' || this.accountLevel == 'ccp') {
		// 		if (this.selectedClientHolding == 'all') {
		// 			urlApiTransactions = '/v2/rrs/transactions?' + contractsParam + 'date_start=&date_end='

		// 			urlApiHoldings = '/v2/rrs/holdings?hin=' + this.$store.getters.getHin + '&offset=' + skip + '&limit=' + limit
		// 		} else {
		// 			if (this.accountLevel == 'fm') {
		// 				urlApiTransactions = '/v2/rrs/transactions?hin=' + this.selectedClientHolding.attributes.hin + '&accountId=' + this.selectedClientHolding.id + '&' + contractsParam + 'date_start=&date_end='

		// 				urlApiHoldings = '/v2/rrs/holdings?hin=' + this.selectedClientHolding.attributes.hin + '&accountId=' + this.selectedClientHolding.id
		// 			} else {
		// 				urlApiTransactions = '/v2/rrs/transactions?hin=' + this.selectedClientHolding.trade_account.hin + '&accountId=' + this.selectedClientHolding.trade_account.account_id + '&' + contractsParam + 'date_start=&date_end='

		// 				urlApiHoldings = '/v2/rrs/holdings?hin=' + this.selectedClientHolding.trade_account.hin + '&accountId=' + this.selectedClientHolding.trade_account.account_id
		// 			}

		// 			if (this.selectedClientHolding.trade_account.hin.substring(0, 2).toLowerCase() == 'lp') {
		// 				this.clientChosed = 'lp'
		// 			}
		// 		}
		// 	} else if (this.accountLevel == 'lp') {
		// 		urlApiTransactions = '/v2/igx/market-maker/transaction?' + contractsParam + 'date_start=&date_end='

		// 		urlApiHoldings = '/v2/igx/market-maker/holding'
		// 	}
		// 	else {
		// 		urlApiTransactions = '/v2/igx/transactions?' + contractsParam + 'date_start=&date_end='

		// 		urlApiHoldings = '/v2/igx/holding'
		// 	}


		// 	// this.holdingsStatus = 'loading'
		// 	// const response = await axios.all([
		// 	// 	axios.post(urlApiTransactions, {
		// 	// 		user_id: this.$store.state.userId
		// 	// 	}),
		// 	// 	axios.post(urlApiHoldings, {
		// 	// 		user_id: this.$store.state.userId
		// 	// 	}),
		// 	// ])

		// 	let resTransactions, resHoldings
		// 	try {
		// 		resTransactions = await axios.post(urlApiTransactions, {
		// 			user_id: this.$store.state.userId
		// 		})

		// 		resHoldings = await axios.post(urlApiHoldings, {
		// 			user_id: this.$store.state.userId
		// 		})
		// 	} catch (error) {
		// 		this.holdingsStatus = 'error'
		// 		return
		// 	}

		// 	this.holdingsPageIndex = 0
		// 	this.holdings = []
		// 	let transactions = resTransactions.data.data.body.data
		// 	let holdings = resHoldings.data.data.body

		// 	if (this.accountLevel == 'fm' || this.accountLevel == 'ib' || this.accountLevel == 'lp') {
		// 		transactions = resTransactions.data.data.body
		// 		holdings = resHoldings.data.data.body
		// 		this.totalHoldings = resHoldings.data.data.count
		// 	}

		// 	console.log('Berhasil holdings', resTransactions, resHoldings, holdings)

		// 	if (holdings.length < 1) {
		// 		this.holdingsStatus = 'idle'
		// 	}

		// 	let sortedHoldings = holdings.sort((a, b) => (a.attributes.accountId > b.attributes.accountId) ? 1 : ((b.attributes.accountId > a.attributes.accountId) ? -1 : 0))

		// 	sortedHoldings.forEach(async (holding) => {
		// 		let contract = contracts.find(obj => obj.id == holding.attributes.contractId)
		// 		const contractConfig = this.$store.getters.getContractConfigs(holding.attributes.contractId)

		// 		let hub = hubs.find(obj => obj.id == contract.attributes.hubId)
		// 		let transactionsNew = transactions.filter(obj => (obj.attributes.contractId == holding.attributes.contractId && obj.attributes.accountId == holding.attributes.accountId && obj.attributes.status == 'match'))
		// 		if (this.accountLevel == 'lp') {
		// 			transactionsNew = transactions.filter(obj => (obj.attributes.contractId == holding.attributes.contractId && obj.attributes.accountId == holding.attributes.accountId))
		// 		}
		// 		let gold = this.$store.getters.goldById(holding.attributes.contractId)

		// 		let totalQuantityBuy = new Decimal(0)
		// 		let totalQuantitySell = new Decimal(0)

		// 		let totalTransactionsBuy = new Decimal(0)
		// 		let totalTransactionsSell = new Decimal(0)

		// 		let totalPricePerGramBuyUsd = new Decimal(0)
		// 		let totalPricePerGramBuyIdr = new Decimal(0)
		// 		let totalPricePerGramSellUsd = new Decimal(0)
		// 		let totalPricePerGramSellIdr = new Decimal(0)

		// 		let totalFeeBuyUsd = new Decimal(0)
		// 		let totalFeeBuyIdr = new Decimal(0)
		// 		let totalFeeSellUsd = new Decimal(0)
		// 		let totalFeeSellIdr = new Decimal(0)

		// 		let totalTaxBuyUsd = new Decimal(0)
		// 		let totalTaxBuyIdr = new Decimal(0)
		// 		let totalTaxSellUsd = new Decimal(0)
		// 		let totalTaxSellIdr = new Decimal(0)

		// 		console.log('transactionsNew', transactions, transactionsNew)

		// 		transactionsNew.forEach((transactionNew) => {
		// 			if (!transactionNew.attributes.quantity) {
		// 				return
		// 			}
		// 			if (transactionNew.attributes.direction == 'buy') {
		// 				// let totalGram = Number(Decimal.mul(this.$store.getters.getContractConfigs(transactionNew.attributes.contractId).weightInGram, transactionNew.attributes.quantity).div(this.$store.getters.getContractConfigs(transactionNew.attributes.contractId).weightCorrection))
		// 				// let pricePer = Decimal.div(transactionNew.attributes.metalValueOfTrade, totalGram).div(this.$store.getters.getContractConfigs(transactionNew.attributes.contractId).weightCorrection)

		// 				let pricePer = (Decimal.div(transactionNew.attributes.metalValueOfTrade, Decimal.div(transactionNew.attributes.quantity, this.$store.getters.getContractConfigs(transactionNew.attributes.contractId).weightCorrection)))

		// 				// totalPricePerGramBuyUsd = Decimal.mul(transactionNew.attributes.matchPrice, this.$store.getters.getContractConfigs(transactionNew.attributes.contractId).weightCorrection).toDecimalPlaces(2).plus(totalPricePerGramBuyUsd)
		// 				// totalPricePerGramBuyIdr = Decimal.mul(transactionNew.attributes.matchPrice, this.$store.getters.getContractConfigs(transactionNew.attributes.contractId).weightCorrection).toDecimalPlaces(2).times(transactionNew.attributes.rate).toDecimalPlaces(2).plus(totalPricePerGramBuyIdr)

		// 				totalPricePerGramBuyUsd = totalPricePerGramBuyUsd.plus(pricePer.toDecimalPlaces(2))
		// 				totalPricePerGramBuyIdr = totalPricePerGramBuyIdr.plus(pricePer.times(transactionNew.attributes.rate).toDecimalPlaces(2))

		// 				totalFeeBuyUsd = totalFeeBuyUsd.plus(transactionNew.attributes.fee)
		// 				totalFeeBuyIdr = totalFeeBuyIdr.plus(Decimal.mul(transactionNew.attributes.fee, transactionNew.attributes.rate))

		// 				totalTaxBuyUsd = totalTaxBuyUsd.plus(transactionNew.attributes.tax)
		// 				totalTaxBuyIdr = totalTaxBuyIdr.plus(Decimal.mul(transactionNew.attributes.tax, transactionNew.attributes.rate))

		// 				totalQuantityBuy = totalQuantityBuy.plus(Decimal.div(transactionNew.attributes.quantity, contractConfig.weightCorrection)).toDecimalPlaces(2)

		// 				totalTransactionsBuy = totalTransactionsBuy.plus(1)
		// 			}
		// 			else {

		// 				// let totalGram = Number(Decimal.mul(this.$store.getters.getContractConfigs(transactionNew.attributes.contractId).weightInGram, transactionNew.attributes.quantity).div(this.$store.getters.getContractConfigs(transactionNew.attributes.contractId).weightCorrection))
		// 				// let pricePer = Decimal.div(transactionNew.attributes.metalValueOfTrade, totalGram).div(this.$store.getters.getContractConfigs(transactionNew.attributes.contractId).weightCorrection)

		// 				let pricePer = (Decimal.div(transactionNew.attributes.metalValueOfTrade, Decimal.div(transactionNew.attributes.quantity, this.$store.getters.getContractConfigs(transactionNew.attributes.contractId).weightCorrection)))

		// 				// totalPricePerGramSellUsd = Decimal.mul(transactionNew.attributes.matchPrice, this.$store.getters.getContractConfigs(transactionNew.attributes.contractId).weightCorrection).toDecimalPlaces(2).plus(totalPricePerGramSellUsd)
		// 				// totalPricePerGramSellIdr = Decimal.mul(transactionNew.attributes.matchPrice, this.$store.getters.getContractConfigs(transactionNew.attributes.contractId).weightCorrection).toDecimalPlaces(2).times(transactionNew.attributes.rate).toDecimalPlaces(2).plus(totalPricePerGramSellIdr)

		// 				totalPricePerGramSellUsd = totalPricePerGramSellUsd.plus(pricePer.toDecimalPlaces(2))
		// 				totalPricePerGramSellIdr = totalPricePerGramSellIdr.plus(pricePer.times(transactionNew.attributes.rate).toDecimalPlaces(2))


		// 				totalFeeSellUsd = totalFeeSellUsd.plus(transactionNew.attributes.fee)
		// 				totalFeeSellIdr = totalFeeSellIdr.plus(Decimal.mul(transactionNew.attributes.fee, transactionNew.attributes.rate))

		// 				totalTaxSellUsd = totalTaxSellUsd.plus(transactionNew.attributes.tax)
		// 				totalTaxSellIdr = totalTaxSellIdr.plus(Decimal.mul(transactionNew.attributes.tax, transactionNew.attributes.rate))

		// 				totalQuantitySell = totalQuantitySell.plus(Decimal.div(transactionNew.attributes.quantity, contractConfig.weightCorrection)).toDecimalPlaces(2)

		// 				totalTransactionsSell = totalTransactionsSell.plus(1)
		// 			}

		// 		})

		// 		let averagePricePerGramBuyUsd = totalPricePerGramBuyUsd.div(totalTransactionsBuy).toDecimalPlaces(3)
		// 		let averagePricePerGramBuyIdr = totalPricePerGramBuyIdr.div(totalTransactionsBuy).toDecimalPlaces(3)
		// 		let averagePricePerGramSellUsd = totalPricePerGramSellUsd.div(totalTransactionsSell).toDecimalPlaces(3)
		// 		let averagePricePerGramSellIdr = totalPricePerGramSellIdr.div(totalTransactionsSell).toDecimalPlaces(3)

		// 		if (totalTransactionsSell == 0) {
		// 			averagePricePerGramSellUsd = 0
		// 			averagePricePerGramSellIdr = 0
		// 		}

		// 		if (totalTransactionsBuy == 0) {
		// 			averagePricePerGramBuyUsd = 0
		// 			averagePricePerGramBuyIdr = 0
		// 		}

		// 		const averageMetalCostBuyUsd = totalQuantityBuy.times(averagePricePerGramBuyUsd).toDecimalPlaces(2)
		// 		const averageMetalCostBuyIdr = totalQuantityBuy.times(averagePricePerGramBuyIdr).toDecimalPlaces(2)
		// 		const averageMetalCostSellUsd = totalQuantitySell.times(averagePricePerGramSellUsd).toDecimalPlaces(2)
		// 		const averageMetalCostSellIdr = totalQuantitySell.times(averagePricePerGramSellIdr).toDecimalPlaces(2)

		// 		const averageMetalCostUsd = averageMetalCostBuyUsd.minus(averageMetalCostSellUsd)
		// 		const averageMetalCostIdr = averageMetalCostBuyIdr.minus(averageMetalCostSellIdr)

		// 		const totalFeeAndTaxBuyUsd = totalFeeBuyUsd.plus(totalTaxBuyUsd)
		// 		const totalFeeAndTaxBuyIdr = totalFeeBuyIdr.plus(totalTaxBuyIdr)
		// 		const totalFeeAndTaxSellUsd = totalFeeSellUsd.plus(totalTaxSellUsd)
		// 		const totalFeeAndTaxSellIdr = totalFeeSellIdr.plus(totalTaxSellIdr)

		// 		const totalFeeAndTaxUsd = totalFeeAndTaxBuyUsd.plus(totalFeeAndTaxSellUsd)
		// 		const totalFeeAndTaxIdr = totalFeeAndTaxBuyIdr.plus(totalFeeAndTaxSellIdr)

		// 		const averageTotalCostIncFeeAndTaxBuyUsd = averageMetalCostBuyUsd.plus(totalFeeAndTaxBuyUsd).toDecimalPlaces(2)
		// 		const averageTotalCostIncFeeAndTaxBuyIdr = averageMetalCostBuyIdr.plus(totalFeeAndTaxBuyIdr).toDecimalPlaces(2)
		// 		const averageTotalCostIncFeeAndTaxSellUsd = averageMetalCostSellUsd.minus(totalFeeAndTaxSellUsd).toDecimalPlaces(2)
		// 		const averageTotalCostIncFeeAndTaxSellIdr = averageMetalCostSellIdr.minus(totalFeeAndTaxSellIdr).toDecimalPlaces(2)

		// 		const averageTotalCostIncFeeAndTaxUsd = averageTotalCostIncFeeAndTaxBuyUsd.minus(averageTotalCostIncFeeAndTaxSellUsd)
		// 		const averageTotalCostIncFeeAndTaxIdr = averageTotalCostIncFeeAndTaxBuyIdr.minus(averageTotalCostIncFeeAndTaxSellIdr)

		// 		const totalQuantity = totalQuantityBuy.minus(totalQuantitySell)

		// 		console.log(
		// 			`
		// 						Contract Id: ${holding.attributes.contractId}

		// 						---

		// 						BUY Total Transactions New: ${transactionsNew}

		// 						BUY Total Transactions Buy: ${totalTransactionsBuy}

		// 						BUY Total Price Per Gram: ${totalPricePerGramBuyUsd}
		// 						BUY Total Price Per Gram Average: ${averagePricePerGramBuyUsd}

		// 						BUY Total Quantity: ${totalQuantityBuy}
		// 						BUY Total Fee: ${totalFeeBuyUsd}
		// 						BUY Total Tax: ${totalTaxBuyUsd}

		// 						BUY Average Metal Cost: ${averageMetalCostBuyUsd}
		// 						BUY Fee & Tax: ${totalFeeAndTaxBuyUsd}
		// 						BUY Average Total Cost Inc. Fee & Tax: ${averageTotalCostIncFeeAndTaxBuyUsd}

		// 						---

		// 						SELL Total Price Per Gram: ${totalPricePerGramSellUsd}
		// 						SELL Total Price Per Gram Average: ${averagePricePerGramSellUsd}

		// 						SELL Total Quantity: ${totalQuantitySell}
		// 						SELL Total Fee: ${totalFeeSellUsd}
		// 						SELL Total Tax: ${totalTaxSellUsd}

		// 						SELL Average Metal Cost: ${averageMetalCostSellUsd}
		// 						SELL Fee & Tax: ${totalFeeAndTaxSellUsd}
		// 						SELL Average Total Cost Inc. Fee & Tax: ${averageTotalCostIncFeeAndTaxSellUsd}

		// 						---

		// 						Average Metal Cost: ${averageMetalCostUsd}
		// 						Fee & Tax: ${totalFeeAndTaxUsd}
		// 						Average Total Cost Inc. Fee & Tax: ${averageTotalCostIncFeeAndTaxUsd}


		// 					`
		// 		)

		// 		let weight = contractConfig.weightInGram

		// 		this.totalGoldLp = this.totalGoldLp.plus(Decimal.mul(Decimal.div(weight, contractConfig.weightCorrection), holding.attributes.value))

		// 		this.holdings.push({
		// 			id: holding.id,
		// 			contractId: holding.attributes.contractId,
		// 			hin: 'loadingTemp',
		// 			account: 'loadingTemp',
		// 			product: contractConfig.name,
		// 			hub: hub.attributes.iata,
		// 			quantity: new Decimal(holding.attributes.value),
		// 			quantityShown: Decimal.div(holding.attributes.value, contractConfig.weightCorrection),
		// 			totalGram: Decimal.mul(weight, totalQuantity).toNumber(),
		// 			averageMetalCostUsd: averageMetalCostUsd,
		// 			averageMetalCostIdr: averageMetalCostIdr,
		// 			totalFeeAndTaxUsd: totalFeeAndTaxUsd,
		// 			totalFeeAndTaxIdr: totalFeeAndTaxIdr,
		// 			averageTotalCostIncFeeAndTaxUsd: averageTotalCostIncFeeAndTaxUsd,
		// 			averageTotalCostIncFeeAndTaxIdr: averageTotalCostIncFeeAndTaxIdr,
		// 			totalQuantity: totalQuantity
		// 		})

		// 		const response2 = await new Promise((resolve) => {
		// 			axios.get('/v2/rrs/get/hin?accountId=' + holding.attributes.accountId
		// 			).then((responseHin) => {
		// 				return resolve(responseHin.data.data.body)
		// 			}).catch(() => {
		// 				return resolve('-')
		// 			})
		// 		})

		// 		const clientHin = response2
		// 		let client
		// 		let accountName = '-'
		// 		if (this.accountLevel == 'fm') {
		// 			// client = this.listClients.find(obj => obj.attributes.hin == clientHin)
		// 			client = this.listClients.find(obj => obj.trade_account.hin == clientHin)
		// 		} else {
		// 			client = this.listClients.find(obj => obj.trade_account.hin == clientHin)
		// 		}

		// 		if (client && this.accountLevel == 'fm') {
		// 			// accountName = client.attributes.name || '-'
		// 			accountName = client.fullname || '-'
		// 		} else if (client && this.accountLevel == 'ib') {
		// 			accountName = client.fullname || '-'
		// 		}

		// 		const targetIndex = this.holdings.findIndex(obj => obj.id == holding.id)


		// 		this.$set(this.holdings[targetIndex], 'hin', clientHin)
		// 		this.$set(this.holdings[targetIndex], 'account', accountName)
		// 	})

		// 	this.holdingsStatus = 'idle'
		// },
	},
}
</script>

<style scoped></style>
